<script>
import { PhxVideoPlayerPlaylist } from '@phx-styleguides/jlc';
import modalMixin from '@phoenix/mixins/modalMixin';
import Modal from '@maison/components/common/Modal.vue';
import { closeModal } from '@phoenix/helpers/modal-helper';

export default {
  components: {
    PhxVideoPlayerPlaylist,
    Modal,
  },

  mixins: [modalMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    playlist: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      i18n: {
        close: this.$t('Button.close'),
        buttonText: this.$t('InTheMaking.watchNow'),
        buttonTextContinueWatching: this.$t('InTheMaking.continueWatching'),
        title: this.$t('Accessibility.mediaPlayer.title'),
        disableCaptions: this.$t('Accessibility.mediaPlayer.disableCaptions'),
        enableCaptions: this.$t('Accessibility.mediaPlayer.enableCaptions'),
        forward: this.$t('Accessibility.mediaPlayer.forward'),
        exitFullscreen: this.$t('Accessibility.mediaPlayer.exitFullscreen'),
        enterFullscreen: this.$t('Accessibility.mediaPlayer.enterFullscreen'),
        pip: this.$t('Accessibility.mediaPlayer.pip'),
        play: this.$t('Accessibility.mediaPlayer.play'),
        pause: this.$t('Accessibility.mediaPlayer.pause'),
        nextVideo: this.$t('Accessibility.mediaPlayer.nextVideo'),
        previousVideo: this.$t('Accessibility.mediaPlayer.previousVideo'),
        playlist: this.$t('Accessibility.mediaPlayer.playlist'),
        currentTime: this.$t('Accessibility.mediaPlayer.currentTime'),
        duration: this.$t('Accessibility.mediaPlayer.duration'),
        seek: this.$t('Accessibility.mediaPlayer.seek'),
        rewind: this.$t('Accessibility.mediaPlayer.rewind'),
        toggleMute: this.$t('Accessibility.mediaPlayer.toggleMute'),
        volume: this.$t('Accessibility.mediaPlayer.volume'),
      },
      currentIndex: 0,
    };
  },

  computed: {
    modalOptions() {
      return {
        onShow: (event) => {
          const episodeIndex = Number.parseInt(event.target.getAttribute('data-episode-index')) ?? null;
          if (episodeIndex === null || episodeIndex === undefined) {
            return;
          }

          this.currentIndex = episodeIndex;
        },
      };
    },
  },

  methods: {
    closeModal() {
      closeModal(this.id);
    },
  },
};
</script>

<template>
  <modal
    :id="id"
    :fullscreen="true"
    :naked="true"
    :should-display-header="false"
    :has-footer-slot="false"
    :should-wrap-content="false"
    :options="modalOptions"
  >
    <template #content>
      <phx-video-player-playlist
        :title="title"
        :current-episode-index="currentIndex"
        :playlist="playlist"
        :i18n="i18n"
        @close="closeModal()"
      ></phx-video-player-playlist>
    </template>
  </modal>
</template>
